FD.MEDIA_MANAGER = (function ($, me) {
    'use strict';

    var child = me.MEDIA_MANAGER || {};


    /* ========================================================================
     *  vars
     * ========================================================================
    */
    var URL_MEDIA = '/Common/Media/';

    var UPLOAD_MODAL = '#UPLOAD_MEDIA_MODAL';
    var MANAGE_MODAL = '#MANAGE_MEDIA_MODAL';
    var MEDIA_SAVE = '#MEDIA_SAVE';

    var k; // used for keyboard events
    var currentFile;

    var clipboard, ctx, canvas;
    var lrPad = 30;
    var pastedImage;
    var origHeight;
    var origWidth;
    var addCallback;
    var deleteCallback;
    var skipDelete = false;
    var uploadMediaHideFunction;
    var manageMediaHideFunction;
    var mediaList;
    var currentMediaID;
    var permissionType;
    var showTitleAndDescription;
    var showWatermark;
    var showArrows = false;
    var notify = new Notify();
    var label;

    /* ========================================================================
     *  tags
     * ========================================================================
    */

    var tag = {
        SAVE_MEDIA: 1000,
        CLEAR_MEDIA: 1001,
        CLICK_IMAGE: 1002,
        EDIT_MediaTitle: 1003,
        EDIT_MediaComment: 1004,
        DELETE_IMAGE: 1005,
        CLICK_PREV: 1006,
        CLICK_NEXT: 1007
    };    


    /* ========================================================================
     *  object
     * ========================================================================
    */


    //  load media manager
    function loadMediaManager(idList, firstID) {
        if (me.getModalLock()) {
            return;
        }
        me.setModalLock(true);
        mediaList = idList;
        showArrows = idList.length > 1;
        var options = {
            url: URL_MEDIA + "MediaManager",
            params: {
                Images: idList,
                firstID: firstID,
                permissionType: permissionType,
                showTitleAndDesc: showTitleAndDescription,
                showWatermark: showWatermark
            },
            callback: afterData,
            isloader: true
        };

        me.AJAX.setAJAX(options);

        function afterData(data) {
            var result = data.data;

            $('body').append(result[0]);
            currentMediaID = +result[1];

            var modal = $(MANAGE_MODAL);

            modal.off().on('shown.bs.modal', function () {
                me.setToolTipDestroy();
                me.CONTROL.setText(true, modal);
                me.CONTROL.setTextArea(true, modal);
                me.CONTROL.setButton(true, modal);
                me.CONTROL.setScroll(modal);
                me.setModalLock(false);
            }).on('hidden.bs.modal', function () {
                me.setToolTip();
                $(MANAGE_MODAL).remove();
                if (manageMediaHideFunction && typeof manageMediaHideFunction === 'function') {
                    manageMediaHideFunction();
                }
            }).modal('show');
        }
    }


    //  load media manager
    function loadMediaUploader(showTitleAndDesc) {
        if (me.getModalLock()) {
            return;
        }
        me.setModalLock(true);
        var options = {
            url: URL_MEDIA + "MediaUploader",
            params: { showTitleAndDesc: typeof (showTitleAndDesc) == 'undefined' ? false : showTitleAndDesc },
            callback: afterData,
            ishtml: true,
            isloader: true
        };

        me.AJAX.setAJAX(options);

        function afterData(data) {
            var result = data.data;

            $('body').append(result);
            var modal = $(UPLOAD_MODAL);

            modal.off().on('shown.bs.modal', function () {
                me.setToolTipDestroy();             
                var options = {         //  dropzone
                    container: '[data-fd="dropzone"]',
                    url: URL_MEDIA + 'VerifyImage'
                };
                if (modal.find('[data-fd="dropzone"]').length > 0) {
                    setMediaDropzone(options);
                    setClipboard(true);
                }
                me.CONTROL.setButton(true, modal);
                me.CONTROL.setText(true, modal);
                me.CONTROL.setTextArea(true, modal);
                $(MEDIA_SAVE).prop('disabled', true);
                me.setModalLock(false);
            }).on('hidden.bs.modal', function () {
                me.setToolTip();
                $(UPLOAD_MODAL).remove();
                if (uploadMediaHideFunction && typeof uploadMediaHideFunction === 'function') {
                    uploadMediaHideFunction();
                }
            }).modal('show');
        }
    }


    function displayIncompatibleMessage() {
        if (me.getModalLock()) {
            return;
        }
        me.setModalLock(true);
        var options = {
            url: URL_MEDIA + "IncompatibleBrowser",
            params: {},
            callback: afterData,
            ishtml: true
        };

        me.AJAX.setAJAX(options);

        function afterData(data) {
            var result = data.data;

            $('body').append(result);

            var modal = $(UPLOAD_MODAL);

            modal.off().on('shown.bs.modal', function () {
                me.setToolTipDestroy();
                me.setModalLock(false);
            }).on('hidden.bs.modal', function () {
                me.setToolTip();
                $(UPLOAD_MODAL).remove();
            }).modal('show');
        }
    }


    // get larger-size image and title/comment information
    function getImageDetails(data) {
        if (data) {
            currentMediaID = +data.parentid;
        }
        var options = {
            url: URL_MEDIA + "GetImageDetails",
            params: {
                mediaID: currentMediaID,
                permissionType: permissionType,
                showArrows: showArrows,
                showTitleAndDesc: showTitleAndDescription,
                showWatermark: showWatermark
            },
            callback: afterData,
            isloader: true
        };

        me.AJAX.setAJAX(options);

        function afterData(data) {
            var result = data.data;
            $('#IMAGE_DIV').html(result[0]);
            $(MANAGE_MODAL).find('.modal-footer').html(result[1]);
            $('#IMAGE_LINK').attr('href', $('#MEDIA_IMAGE').data('url'));
            me.CONTROL.setButton(true, null);
            me.CONTROL.setText(true, null);
            me.CONTROL.setTextArea(true, null);
            if (mediaList.length === 1) {
                $("#THUMBNAIL_LIST").parent().remove();
                $("#IMAGE_DIV").removeClass('col-xs-10').addClass('col-xs-12');
            }
        }
    }


    // click the previous or next button
    function handleImageNavigation(data) {
        var index = jQuery.inArray(currentMediaID, mediaList);
        if (data.tag === tag.CLICK_PREV) {
            index = index === 0 ? mediaList.length - 1 : index - 1;
        } else {
            index = (index + 1) % mediaList.length;
        }

        currentMediaID = mediaList[index];
        getImageDetails();
    }


    // create a media item object
    function setMediaItem(ID) {
        return {
            MediaID: ID,
            MediaTitle: null,
            MediaComment: null
        };
    }


    // update the title/comment information for a media item
    function handleMediaFieldCRUD(data) {
        var mediaItem = setMediaItem(data.parentid);
        if (data.tag === tag.EDIT_MediaTitle) {
            mediaItem.MediaTitle = data.value;
        } else {
            mediaItem.MediaComment = data.value;
        }

        var options = {
            url: URL_MEDIA + "HandleMediaFieldCRUD",
            params: {
                item: mediaItem
            },
            isloader: true
        };

        me.AJAX.setAJAX(options);
    }


    // delete an image
    function handleMediaDeleteCRUD(data) {
        var options = {
            url: URL_MEDIA + "HandleMediaDeleteCRUD",
            params: {
                mediaID: currentMediaID
            },
            callback: afterData,
            isloader: true
        };

        if (skipDelete) {
            afterData({ data: true });
        } else {
            me.AJAX.setAJAX(options);
        }

        function afterData(result) {
            if (result.data) {
                var index = jQuery.inArray(currentMediaID, mediaList);
            
                //If there's at least one image left, update the thumbnail list and display the next image
                if (mediaList.length > 1) {
                    deleteCallback(currentMediaID);
                    $('#THUMBNAIL_LIST>div').eq(index).remove();
                    mediaList.splice(index, 1);
                    index = index === 0 || index === mediaList.length ? mediaList.length - 1 : index;
                    currentMediaID = mediaList[index];
                    showArrows = mediaList.length !== 1;
                    getImageDetails();
                } else { // No images left - close the modal
                    deleteCallback(currentMediaID);
                    $(MANAGE_MODAL).modal('hide');
                }
            }
        }
    }


    //-------------------------------------------------------------
    // Image Upload Functions (paste/drag/browse)
    //-------------------------------------------------------------var clipboard, ctx, canvas;

    //  set dropzone
    function setMediaDropzone(options) {

        //  don't load dz on init
        Dropzone.autoDiscover = false;

        //  set options
        var defaults = {
            maxFilesize: 20, // MB
            maxFiles: 1,
            url: '',
            callback: '',
            fileParam: 'image',
            container: '',
            userguid: '',
            entityname: '',
            username: '',
            dropzone: true
        };

        //  set options
        var opts = $.extend({}, defaults, options);
        opts.success = false;

        if (typeof opts.container === 'string') {
            opts.container = $(opts.container);
        }

        var dZ = opts.container;
        if (dZ.length === 0) {
            return;
        }

        //  callback
        function handleCallback(files, response) {
            ctx.clearRect(0, 0, canvas.width, canvas.height);
            currentFile = files;
            $(MEDIA_SAVE).removeClass('disabled btn-default').addClass('btn-primary').prop("disabled", null);

            var reader = new FileReader();
            reader.onload = function (event) {
                var image = new Image();
                image.onload = function () {
                    //resize canvas
                    var maxWidth = Math.min($(window).width(), $(UPLOAD_MODAL).width()) - lrPad;
                    var maxHeight = Math.min($(window).height(), $(UPLOAD_MODAL).height());
                    canvas.width = image.width;
                    canvas.height = image.height;

                    while (canvas.width > maxWidth) {
                        canvas.width = canvas.width * .75;
                        canvas.height = canvas.height * .75;
                    }
                    while (canvas.height > maxHeight) {
                        canvas.width = canvas.width * .75;
                        canvas.height = canvas.height * .75;
                    }
                    ctx.drawImage(image, 0, 0, canvas.width, canvas.height);
                };

                image.src = this.result;
            };

            reader.readAsDataURL(files);
        }


        //  init
        dZ.dropzone({
            paramName: opts.fileParam,
            maxFilesize: opts.maxFilesize,
            autoProcessQueue: true,
            uploadMultiple: false,
            parallelUploads: 1,
            maxFiles: opts.maxFiles,
            maxThumbnailFilesize: 1,
            acceptedFiles: "image/*",
            clickable: true,
            url: opts.url,
            init: function () {
                var myDropzone = this;

                this.on("success", function (file, response) {
                    myDropzone.removeAllFiles(file);
                    handleCallback(file, response);
                }).on('complete', function (file) {
                    if (!file.accepted) {
                        if (!label) {
                            label = me.getLabel();
                        }
                        notify.alert(label["ImageExceedsMaximumSizeAlert"]);
                    }
                });
            }
        });
    }


    function setClipboard(autoresize) {
        clipboard = new CLIPBOARD_CLASS('MEDIA_CANVAS', autoresize);
    }


    // save pasted/dragged/uploaded image
    function saveImage(data) {
        data.e.find('img').attr('onerror', null);
        var originalHtml = $.parseHTML(data.e.html());
        data.e.addClass('disabled').prop('disabled', true).html('<i class="fa fa-fw fa-spinner fa-spin"></i>');
        var fieldData = me.getFormFields(data.e.closest(".modal"));
        if (currentFile) {            
            var formData = new FormData();
            formData.append("image", currentFile);
            formData.append("MediaTitle", fieldData.MediaTitle);
            formData.append("MediaComment", fieldData.MediaComment);

            var options = {
                url: URL_MEDIA + "HandleImageUpload",
                params: formData,
                callback: afterData,
                isloader: true,
                processData: false,
                contentType: false,
            };

            me.AJAX.setAJAX(options);
        } else {
            var image = canvas.toDataURL("image/jpeg");
            image = image.replace('data:image/jpeg;base64,', '');

            var options = {
                url: URL_MEDIA + "HandleScreenshotUpload",
                params: {
                    imageData: image,
                    width: pastedImage.width,
                    height: pastedImage.height,
                    mediaTitle: fieldData.MediaTitle,
                    mediaComment: fieldData.MediaComment
                },
                callback: afterData,
                isloader: true,
                contentType: 'application/json; charset=utf-8',
            };

            me.AJAX.setAJAX(options);
        }

        function afterData(result) {
            if (result.data) {
                currentFile = null;
                addCallback(result.data, result.getResponseHeader('MediaGUID'));
                $('[data-fldname="MediaTitle"]').val('');
                $('[data-fldname="MediaComment"]').val('');
                clearCanvas();
            }
            data.e.removeClass('disabled').prop('disabled', null).html(originalHtml);
        }
    }


    // remove current file, clear canvas, and restore it to original size
    function clearCanvas() {
        currentFile = null;
        $(MEDIA_SAVE).removeClass('btn-primary').addClass('disabled btn-default').prop("disabled", true);

        ctx.clearRect(0, 0, canvas.width, canvas.height);
        canvas.width = origWidth;
        canvas.height = origHeight;
        ctx.font = "16px Noto Sans";
        ctx.fillStyle = "#466174";
        ctx.fillText("You can upload an image by:", 25, 50, canvas.width - 100);
        ctx.fillText("1. Dragging an image onto this canvas", 50, 90, canvas.width - 100);
        ctx.fillText("2. Pressing [Ctrl+V] to paste a screenshot", 50, 120, canvas.width - 100);
        ctx.fillText("3. Clicking this box to upload an image", 50, 150, canvas.width - 100);
    }


    /**
     * image pasting into canvas
     * 
     * @param string canvas_id canvas id
     * @param boolean autoresize if canvas will be resized
     */
    function CLIPBOARD_CLASS(canvas_id, autoresize) {
        var _self = this;
        canvas = document.getElementById(canvas_id);
        origWidth = canvas.width;
        origHeight = canvas.height;
        ctx = document.getElementById(canvas_id).getContext("2d");
        ctx.font = "16px Noto Sans";
        ctx.fillStyle = "#466174";
        ctx.fillText("You can upload an image by:", 25, 50, canvas.width - 100);
        ctx.fillText("1. Dragging an image onto this canvas", 50, 90, canvas.width - 100);
        ctx.fillText("2. Pressing [Ctrl+V] to paste a screenshot", 50, 120, canvas.width - 100);
        ctx.fillText("3. Clicking this box to upload an image", 50, 150, canvas.width - 100);
        var ctrl_pressed = false;
        var reading_dom = false;
        var text_top = 15;
        var pasteCatcher;
        var paste_mode;

        //handlers
        document.addEventListener('keydown', function (e) {
            _self.on_keyboard_action(e);
        }, false); //firefox fix
        document.addEventListener('keyup', function (e) {
            _self.on_keyboardup_action(e);
        }, false); //firefox fix
        document.addEventListener('paste', function (e) {
            _self.paste_auto(e);
        }, false); //official paste handler

        //constructor - prepare
        this.init = function () {
            //if using auto
            //if (window.Clipboard)
            //    return true;
            // Greg took out the above lines on 6/9/2017, because the universal inclusion of clipboard.js for the IAS PO Modal
            // ended up causing this statement the always return true. Since we aren't currently using the clipboard.js
            // functionality on any page that also uses the media manager right now, I think we should be ok.
            if ($('#paste_ff').length) {
                pasteCatcher = $('#paste_ff')[0];
                return;
            }
            pasteCatcher = document.createElement("div");
            pasteCatcher.setAttribute("id", "paste_ff");
            pasteCatcher.setAttribute("contenteditable", "");
            pasteCatcher.style.cssText = 'opacity:0;position:fixed;top:0px;left:0px;';
            pasteCatcher.style.marginLeft = "-20px";
            pasteCatcher.style.width = "10px";
            document.body.appendChild(pasteCatcher);
            document.getElementById('paste_ff').addEventListener('DOMSubtreeModified', function () {
                if (paste_mode == 'auto' || ctrl_pressed == false)
                    return true;
                //if paste handle failed - capture pasted object manually
                if (pasteCatcher.children.length == 1) {
                    if (pasteCatcher.firstElementChild.src != undefined) {
                        //image
                        _self.paste_createImage(pasteCatcher.firstElementChild.src);
                    }
                }
                //register cleanup after some time.
                setTimeout(function () {
                    pasteCatcher.innerHTML = '';
                }, 20);
            }, false);
        }();
        //default paste action
        this.paste_auto = function (e) {
            paste_mode = '';
            pasteCatcher.innerHTML = '';
            var plain_text_used = false;
            if (e.clipboardData) {
                var items = e.clipboardData.items;
                if (items) {
                    paste_mode = 'auto';
                    //access data directly
                    for (var i = 0; i < items.length; i++) {
                        if (items[i].type.indexOf("image") !== -1) {
                            //image
                            var blob = items[i].getAsFile();
                            var URLObj = window.URL || window.webkitURL;
                            var source = URLObj.createObjectURL(blob);
                            this.paste_createImage(source);
                        }
                    }
                    e.preventDefault();
                }
                else {
                    //wait for DOMSubtreeModified event
                    //https://bugzilla.mozilla.org/show_bug.cgi?id=891247
                }
            }
        };
        //on keyboard press - 
        this.on_keyboard_action = function (event) {
            k = event.keyCode;
            //ctrl
            if (k == 17 || event.metaKey || event.ctrlKey) {
                if (ctrl_pressed == false)
                    ctrl_pressed = true;
            }
            //c
            if (k == 86) {
                if (document.activeElement != undefined && document.activeElement.type == 'text') {
                    //let user paste into some input
                    return false;
                }

                if (ctrl_pressed == true)// && !window.Clipboard) Taken out due to inclusion of cliboard.js
                    pasteCatcher.focus();
            }
        };
        //on kaybord release
        this.on_keyboardup_action = function (event) {
            k = event.keyCode;
            //ctrl
            if (k == 17 || event.metaKey || event.ctrlKey || event.key == 'Meta')
                ctrl_pressed = false;
        };
        //draw image
        this.paste_createImage = function (source) {
            pastedImage = new Image();
            pastedImage.onload = function () {
                if (autoresize == true) {
                    //resize canvas
                    var maxWidth = Math.min($(window).width(), $(UPLOAD_MODAL).width()) - lrPad;
                    var maxHeight = Math.min($(window).height(), $(UPLOAD_MODAL).height());
                    canvas.width = pastedImage.width;
                    canvas.height = pastedImage.height;
                    while (canvas.width > maxWidth) {
                        canvas.width = canvas.width * .75;
                        canvas.height = canvas.height * .75;
                    }
                    while (canvas.height > maxHeight) {
                        canvas.width = canvas.width * .75;
                        canvas.height = canvas.height * .75;
                    }
                }
                else {
                    //clear canvas
                    ctx.clearRect(0, 0, canvas.width, canvas.height);
                }
                ctx.drawImage(pastedImage, 0, 0, canvas.width, canvas.height);
                $(MEDIA_SAVE).removeClass('disabled btn-default').addClass('btn-primary').prop("disabled", null);
            };
            pastedImage.src = source;
        };
    }


    function getBrowserVersion() {
        var ua = navigator.userAgent, tem,
        M = ua.match(/(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i) || [];
        if (/trident/i.test(M[1])) {
            tem = /\brv[ :]+(\d+)/g.exec(ua) || [];
            return { name: 'IE', version: (tem[1] || '') };
        }
        if (M[1] === 'Chrome') {
            tem = ua.match(/\b(OPR|Edge)\/(\d+)/);
            if (tem != null) return { name: tem[1].replace('OPR', 'Opera'), version: tem[2] };
        }
        M = M[2] ? [M[1], M[2]] : [navigator.appName, navigator.appVersion, '-?'];
        if ((tem = ua.match(/version\/(\d+)/i)) != null) M.splice(1, 1, tem[1]);
        return { name: M[0], version: M[1] };
    }


    //  set after control event
    //  handle all interface events here
    function setAfterControlEvent(data) {
        var result = data;

        // save pasted/dragged/uploaded image
        if (result.tag === tag.SAVE_MEDIA) saveImage(result);

        // clear canvas
        if (result.tag === tag.CLEAR_MEDIA) clearCanvas();

        // click image
        if (result.tag === tag.CLICK_IMAGE) getImageDetails(result);

        // edit title or comment
        if (result.tag === tag.EDIT_MediaTitle ||
            result.tag === tag.EDIT_MediaComment) handleMediaFieldCRUD(result);

        // delete image
        if (result.tag === tag.DELETE_IMAGE) handleMediaDeleteCRUD(result);

        // prev/next button
        if (result.tag === tag.CLICK_PREV ||
            result.tag === tag.CLICK_NEXT) handleImageNavigation(result);

        // view full size image
        if (result.tag === tag.CLICK_FULLSIZE) viewFullSize(result);
        
    }


    /* ========================================================================
     *  vars
     * ========================================================================
    */


    child.loadMediaUploader = function (addFunction, hideFunction, showTitleAndDesc) {
        addCallback = addFunction;
        uploadMediaHideFunction = hideFunction;

        var browserDetect = getBrowserVersion();
        if (browserDetect.name === "MSIE" && +browserDetect.version < 11) {
            displayIncompatibleMessage();
        } else {
            loadMediaUploader(showTitleAndDesc);
        }
    };


    child.closeMediaUploader = function () {
        $(UPLOAD_MODAL).modal("hide");
    }

    /*
     Load the media manager.
     Parameters:
       idList: the list of media IDs that need to be shown
       firstID: the ID of the image that should be shown first
       deleteFunction: callback for when the user deletes a picture. Provides a single ID parameter
       hideFunction: callback for when the user hides the media modal.
       permission: used to determine if the picture can be edited/deleted. Use me.MEDIA_MANAGER.getMediaPermissions() to see the available options.
     */
    child.loadMediaManager = function (idList, firstID, deleteFunction, hideFunction, permission, showTitleAndDesc, skipDeleteImage, showWatermarks) {
        deleteCallback = deleteFunction;
        skipDelete = skipDeleteImage;
        manageMediaHideFunction = hideFunction;
        permissionType = (permission) ? permission : 1;
        showTitleAndDescription = (showTitleAndDesc == null) ? true : showTitleAndDesc;
        showWatermark = showWatermarks;
        loadMediaManager(idList, firstID);
    };


    child.closeMediaManager = function () {
        $(MANAGE_MODAL).modal("hide");
    }


    child.getMediaPermissions = function () {
        return {
            All: 1,
            Author: 2,
            ReadOnly: 3
        };
    };



    //   after control event
    child.getAfterControlEvent = function (data) {
        setAfterControlEvent(data);
    };

    return child;
}(jQuery, FD));



